module.exports = __webpack_public_path__ + "static/media/report_2.11f5c35a.png";